/* ASPIK - Visor de catalogos en PDF.
   Abre el catalogo dentro de la pagina sin descargarlo completo.
   Dos cosas lo hacen rapido:
     1) los PDF estan linealizados (optimizados para web)
     2) disableStream:true obliga a PDF.js a pedir solo pedazos (Range)

   En escritorio abre por default a DOS PAGINAS y con la pagina completa
   a la vista: el zoom se calcula para que la altura de la hoja quepa en
   la pantalla, no con un numero fijo.

   El buscador compara ignorando espacios, guiones, puntos y acentos,
   porque en los catalogos los codigos vienen como 'AML 5345' y el cliente
   los teclea como 'AML-5345'. */
(function () {
  'use strict';

  var LIB = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.min.js';
  var WORKER = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.worker.min.js';
  var ESCRITORIO = 750;
  var libPromise = null;

  function loadLib() {
    if (libPromise) return libPromise;
    libPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = LIB;
      s.onload = function () {
        var lib = window.pdfjsLib;
        if (!lib) { reject(new Error('sin libreria')); return; }
        lib.GlobalWorkerOptions.workerSrc = WORKER;
        resolve(lib);
      };
      s.onerror = function () { reject(new Error('no cargo')); };
      document.head.appendChild(s);
    });
    return libPromise;
  }

  var V = {};
  var root = null;

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function btn(cls, label, html) {
    var b = el('button', 'aspik-viewer__btn ' + cls, html);
    b.type = 'button';
    b.setAttribute('aria-label', label);
    b.title = label;
    return b;
  }

  function build() {
    if (root) return root;
    root = el('div', 'aspik-viewer', '');
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.hidden = true;

    var bar = el('div', 'aspik-viewer__bar');
    var title = el('span', 'aspik-viewer__title');
    var pager = el('span', 'aspik-viewer__pager');
    var tools = el('div', 'aspik-viewer__tools');

    var bPrev = btn('is-prev', 'Pagina anterior', '&#8249;');
    var bNext = btn('is-next', 'Pagina siguiente', '&#8250;');
    var bFind = btn('is-find', 'Buscar en el catalogo', '<svg viewBox="0 0 20 20" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="9" r="6"/><path d="M13.5 13.5L18 18" stroke-linecap="round"/></svg>');
    var bSpread = btn('is-spread', 'Ver una pagina', '<svg viewBox="0 0 22 16" width="17" height="13" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="1" y="1" width="9" height="14"/><rect x="12" y="1" width="9" height="14"/></svg>');
    var bFit = btn('is-fit', 'Ajustar a la pantalla', '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M1 5V1h4M15 5V1h-4M1 11v4h4M15 11v4h-4" stroke-linecap="round"/></svg>');
    var bOut  = btn('is-out', 'Alejar', '&minus;');
    var bIn   = btn('is-in', 'Acercar', '+');
    var bDown = el('a', 'aspik-viewer__btn is-down', 'Descargar');
    bDown.setAttribute('download', '');
    bDown.setAttribute('target', '_blank');
    bDown.setAttribute('rel', 'noopener');
    var bClose = btn('is-close', 'Cerrar', '&times;');

    tools.appendChild(bPrev); tools.appendChild(pager); tools.appendChild(bNext);
    tools.appendChild(bFind); tools.appendChild(bSpread); tools.appendChild(bFit);
    tools.appendChild(bOut); tools.appendChild(bIn);
    tools.appendChild(bDown); tools.appendChild(bClose);
    bar.appendChild(title); bar.appendChild(tools);

    var find = el('div', 'aspik-viewer__find');
    find.hidden = true;
    var finput = el('input', 'aspik-viewer__find-input');
    finput.type = 'search';
    finput.placeholder = 'Buscar modelo o palabra…';
    finput.setAttribute('aria-label', 'Buscar en el catalogo');
    var fstate = el('span', 'aspik-viewer__find-state');
    var fclose = btn('is-findclose', 'Cerrar busqueda', '&times;');
    var fhead = el('div', 'aspik-viewer__find-head');
    fhead.appendChild(finput); fhead.appendChild(fstate); fhead.appendChild(fclose);
    var fres = el('ol', 'aspik-viewer__find-results');
    find.appendChild(fhead); find.appendChild(fres);

    var scroller = el('div', 'aspik-viewer__scroll');
    var pages = el('div', 'aspik-viewer__pages');
    var msg = el('p', 'aspik-viewer__msg', 'Cargando catalogo…');
    scroller.appendChild(msg);
    scroller.appendChild(pages);

    root.appendChild(bar);
    root.appendChild(find);
    root.appendChild(scroller);
    document.body.appendChild(root);

    V.title = title; V.pager = pager; V.pages = pages;
    V.scroller = scroller; V.msg = msg; V.down = bDown;
    V.find = find; V.finput = finput; V.fstate = fstate; V.fres = fres;
    V.bSpread = bSpread;

    bClose.addEventListener('click', close);
    bPrev.addEventListener('click', function () { go(-1); });
    bNext.addEventListener('click', function () { go(1); });
    bIn.addEventListener('click', function () { zoom(0.2); });
    bOut.addEventListener('click', function () { zoom(-0.2); });
    bFit.addEventListener('click', function () { fitToHeight(); repaint(); });
    bSpread.addEventListener('click', toggleSpread);
    bFind.addEventListener('click', function () {
      find.hidden = !find.hidden;
      if (!find.hidden) finput.focus();
    });
    fclose.addEventListener('click', function () { find.hidden = true; });
    var deb;
    finput.addEventListener('input', function () {
      clearTimeout(deb);
      deb = setTimeout(function () { doSearch(finput.value.trim()); }, 350);
    });
    finput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); clearTimeout(deb); doSearch(finput.value.trim()); }
    });
    scroller.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { fitToHeight(); repaint(); });
    document.addEventListener('keydown', onKey);
    return root;
  }

  function onKey(e) {
    if (!root || root.hidden) return;
    var typing = document.activeElement === V.finput;
    if (e.key === 'Escape') {
      if (!V.find.hidden) { V.find.hidden = true; return; }
      close();
    } else if (!typing && (e.key === 'ArrowRight' || e.key === 'PageDown')) { e.preventDefault(); go(1); }
    else if (!typing && (e.key === 'ArrowLeft' || e.key === 'PageUp')) { e.preventDefault(); go(-1); }
  }

  function close() {
    root.hidden = true;
    document.documentElement.classList.remove('aspik-viewer-open');
    V.pages.innerHTML = '';
    V.fres.innerHTML = '';
    V.fstate.textContent = '';
    V.find.hidden = true;
    V.cancelSearch = true;
    V.textCache = null;
    V.ratio = null;
    if (V.io) { V.io.disconnect(); V.io = null; }
    if (V.doc) { try { V.doc.destroy(); } catch (err) {} V.doc = null; }
    if (V.opener && V.opener.focus) V.opener.focus();
  }

  function goToPage(n) {
    var w = V.pages.children[n - 1];
    if (w) V.scroller.scrollTo({ top: w.offsetTop - 12, behavior: 'smooth' });
  }

  function go(dir) {
    var step = V.spread ? 2 : 1;
    goToPage(Math.min(Math.max((V.current || 1) + dir * step, 1), V.total || 1));
  }

  function repaint() {
    Array.prototype.forEach.call(V.pages.children, function (w) {
      w.dataset.rendered = '';
      var c = w.querySelector('canvas');
      if (c) c.remove();
    });
    renderVisible();
  }

  function zoom(delta) {
    V.zoom = Math.min(Math.max((V.zoom || 1) + delta, 0.3), 3);
    V.pages.style.setProperty('--aspik-zoom', V.zoom);
    repaint();
  }

  /* Calcula el zoom para que la hoja completa quepa de alto en la pantalla */
  function fitToHeight() {
    if (!V.ratio || !V.pages) return;
    if (window.innerWidth < ESCRITORIO) {
      V.zoom = 1;
      V.pages.style.setProperty('--aspik-zoom', 1);
      return;
    }
    var alto = (V.scroller.clientHeight || 600) - 34;
    var base = V.spread ? 1400 : 820;
    var columnas = V.spread ? 2 : 1;
    var hueco = V.spread ? 6 : 0;
    var anchoTotal = alto * V.ratio * columnas + hueco;
    V.zoom = Math.min(Math.max(anchoTotal / base, 0.3), 3);
    V.pages.style.setProperty('--aspik-zoom', V.zoom);
  }

  function aplicarSpread() {
    V.pages.classList.toggle('is-spread', V.spread);
    V.bSpread.classList.toggle('is-on', V.spread);
    V.bSpread.title = V.spread ? 'Ver una pagina' : 'Ver dos paginas';
  }

  function toggleSpread() {
    V.spread = !V.spread;
    aplicarSpread();
    setTimeout(function () { fitToHeight(); repaint(); }, 30);
  }

  function onScroll() {
    var top = V.scroller.scrollTop + V.scroller.clientHeight * 0.35;
    var kids = V.pages.children, n = 1;
    for (var i = 0; i < kids.length; i++) { if (kids[i].offsetTop <= top) n = i + 1; }
    if (n !== V.current) { V.current = n; V.pager.textContent = n + ' / ' + V.total; }
    renderVisible();
  }

  function renderVisible() {
    if (!V.doc || !V.pages) return;
    var kids = V.pages.children;
    var a = V.scroller.scrollTop - V.scroller.clientHeight;
    var b = V.scroller.scrollTop + V.scroller.clientHeight * 2;
    for (var i = 0; i < kids.length; i++) {
      var w = kids[i];
      if (w.offsetTop + w.offsetHeight > a && w.offsetTop < b) draw(w);
    }
  }

  function draw(wrap) {
    if (!V.doc || wrap.dataset.rendered) return;
    wrap.dataset.rendered = '1';
    var num = parseInt(wrap.dataset.page, 10);
    V.doc.getPage(num).then(function (page) {
      var base = page.getViewport({ scale: 1 });
      var width = wrap.clientWidth || wrap.offsetWidth || 800;
      var scale = (width / base.width) * Math.min(window.devicePixelRatio || 1, 2);
      var vp = page.getViewport({ scale: scale });
      var canvas = document.createElement('canvas');
      canvas.width = Math.floor(vp.width);
      canvas.height = Math.floor(vp.height);
      canvas.setAttribute('aria-label', 'Pagina ' + num);
      wrap.appendChild(canvas);
      return page.render({ canvasContext: canvas.getContext('2d', { alpha: false }), viewport: vp }).promise;
    }).catch(function () { wrap.dataset.rendered = ''; });
  }

  /* ---------- Buscador ---------- */
  function fold(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function compact(s) {
    var out = '', map = [];
    for (var i = 0; i < s.length; i++) {
      var ch = s[i];
      if ((ch >= 'a' && ch <= 'z') || (ch >= '0' && ch <= '9')) { out += ch; map.push(i); }
    }
    return { text: out, map: map };
  }

  function doSearch(term) {
    V.cancelSearch = true;
    V.fres.innerHTML = '';
    if (!V.doc || term.length < 2) { V.fstate.textContent = ''; return; }

    var token = {};
    V.searchToken = token;
    V.cancelSearch = false;
    if (!V.textCache) V.textCache = {};
    var needle = compact(fold(term)).text;
    if (!needle) { V.fstate.textContent = ''; return; }
    var hits = 0;
    var totalChars = 0;

    function addHit(num, text, idx) {
      hits++;
      var from = Math.max(0, idx - 45);
      var frag = (from > 0 ? '…' : '') + text.substr(from, 120).trim() + '…';
      var li = el('li', 'aspik-viewer__find-hit');
      var a = el('button', '', '<strong>Pág. ' + num + '</strong> <span></span>');
      a.type = 'button';
      a.querySelector('span').textContent = frag;
      a.addEventListener('click', function () { goToPage(num); });
      li.appendChild(a);
      V.fres.appendChild(li);
    }

    function step(n) {
      if (V.searchToken !== token || V.cancelSearch) return;
      if (n > V.total) {
        if (hits) {
          V.fstate.textContent = hits + ' resultado' + (hits === 1 ? '' : 's');
        } else if (totalChars < 60) {
          V.fstate.textContent = '';
          var li = el('li', 'aspik-viewer__find-hit');
          li.innerHTML = '<button type="button" disabled><span>Este catálogo está hecho de imágenes, no trae texto que se pueda buscar. Usa las flechas o descárgalo en PDF.</span></button>';
          V.fres.appendChild(li);
        } else {
          V.fstate.textContent = 'Sin resultados';
        }
        return;
      }
      V.fstate.textContent = 'Buscando… ' + n + '/' + V.total + (hits ? ' · ' + hits : '');

      var cached = V.textCache[n];
      var p = cached != null
        ? Promise.resolve(cached)
        : V.doc.getPage(n)
            .then(function (pg) { return pg.getTextContent(); })
            .then(function (tc) {
              var t = tc.items.map(function (i) { return i.str; }).join(' ').replace(/\s+/g, ' ');
              V.textCache[n] = t;
              return t;
            })
            .catch(function () { V.textCache[n] = ''; return ''; });

      p.then(function (text) {
        if (V.searchToken !== token || V.cancelSearch) return;
        totalChars += text.length;
        var c = compact(fold(text));
        var j = c.text.indexOf(needle);
        if (j > -1) addHit(n, text, c.map[j]);
        setTimeout(function () { step(n + 1); }, 0);
      });
    }
    step(1);
  }

  function open(url, name) {
    build();
    V.opener = document.activeElement;
    V.zoom = 1;
    V.current = 1;
    V.total = 0;
    V.doc = null;
    V.ratio = null;
    V.textCache = null;
    V.cancelSearch = true;
    V.spread = window.innerWidth >= ESCRITORIO;
    aplicarSpread();
    V.title.textContent = name;
    V.pager.textContent = '';
    V.down.href = url;
    V.pages.innerHTML = '';
    V.fres.innerHTML = '';
    V.fstate.textContent = '';
    V.finput.value = '';
    V.find.hidden = true;
    V.pages.style.setProperty('--aspik-zoom', 1);
    V.msg.hidden = false;
    V.msg.textContent = 'Cargando catalogo…';
    root.hidden = false;
    V.scroller.scrollTop = 0;
    document.documentElement.classList.add('aspik-viewer-open');

    loadLib().then(function (lib) {
      return lib.getDocument({
        url: url,
        disableStream: true,
        disableAutoFetch: true,
        rangeChunkSize: 65536
      }).promise;
    }).then(function (doc) {
      if (root.hidden) { doc.destroy(); return; }
      V.doc = doc;
      V.total = doc.numPages;
      return doc.getPage(1).then(function (p) {
        var vp = p.getViewport({ scale: 1 });
        V.ratio = vp.width / vp.height;
        V.msg.hidden = true;
        V.pager.textContent = '1 / ' + V.total;
        for (var i = 1; i <= V.total; i++) {
          var w = el('div', 'aspik-viewer__page');
          w.dataset.page = i;
          w.style.aspectRatio = vp.width + ' / ' + vp.height;
          V.pages.appendChild(w);
        }
        fitToHeight();
        if (window.IntersectionObserver) {
          V.io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { if (en.isIntersecting) draw(en.target); });
          }, { root: V.scroller, rootMargin: '150% 0px' });
          Array.prototype.forEach.call(V.pages.children, function (w) { V.io.observe(w); });
        }
        renderVisible();
        setTimeout(function () { fitToHeight(); renderVisible(); }, 250);
      });
    }).catch(function () {
      V.msg.hidden = false;
      V.msg.innerHTML = 'No pudimos abrir el catalogo aqui. <a href="' + url + '" target="_blank" rel="noopener">Abrelo en una pestana nueva</a>.';
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-aspik-pdf]') : null;
    if (!t) return;
    e.preventDefault();
    open(t.getAttribute('data-aspik-pdf'), t.getAttribute('data-aspik-name') || 'Catalogo Aspik');
  });
})();
